<template>
    <div class="subtop">
        <div class="subtop-cont">
            <div class="subtop-title title-2">
                <p>정관 및 규정</p>
                <span>대한서핑협회의 정관 및 규정을 공개 합니다.</span>
            </div>
        </div>
        <img class="subtop-img" src="@/assets/images/img/subtop-1.png">
    </div>
    <!--서뷰메뉴-->
    <div class="sub-menu" style="margin-top: 15px;">
        <ul class="float-wrap">
			<!-- <li class="on"><router-link to="/about-greeting">인사말</router-link></li>
			<li><router-link to="/about-ksa">협회소개</router-link></li>
			<li><router-link to="/about-organization">조직도</router-link></li>
			<li><router-link to="/about-rules">시/도협회</router-link></li> -->

			<div class="tab-container tab-box">
				<div class="tab tab-4">
					<button type="button" @click="setTab(1)" :class="''">인사말</button>
					<button type="button" @click="setTab(2)" :class="''">협회소개</button>
					<button type="button" @click="setTab(3)" :class="''">조직도</button>
					<button type="button" @click="setTab(4)" :class="''">시/도협회</button>
					<button type="button" @click="setTab(5)" :class="'on'">정관·규정</button>
				</div>
			</div>
		</ul>
	</div>
    
    <!--서브내용-->
    <div class="sub-wrap sub-wrap-grey">
        <div class="sub-cont">

			<!--게시판 리스트 (정관·규정) -->
			<div class="board">
				<BoardTop :gridInfo="openNoticeJson" @getGridData="getGridData" v-model="searchText"/>

				<Grid :gridInfo="openNoticeJson" :dataList="noticeList" />

				<Pagination v-if="openNoticeJson.pagination" :gridInfo="openNoticeJson" :editorType="'notice'" :boardType="21" @getGridData="getGridData" />
			</div>

        </div>
    </div>

</template>

<script setup>
	import BoardTop from '@/components/common/grid/boardtop'
	import Grid from '@/components/common/grid/grid'
	import Pagination from '@/components/common/grid/pagination'
	import noticeJson from '@/models/gridInfo/notice.json'
	import { ref, computed, onMounted, onUnmounted } from 'vue'
	import { useStore } from 'vuex'
	import { useRouter } from 'vue-router'

	const store = useStore()
	const router = useRouter()

	let { tree } = store.state.treeMenu

	//탭
	const activeTabId = ref(1)

	const setTab = (tabId) => {
		activeTabId.value = tabId
		if(tabId == 1) {
			router.push({ path : '/about-greeting' })
		}    
		if (tabId == 2) {
			router.push({ path: '/about-ksa' })
		}
		if (tabId == 3) {
			router.push({ path: '/about-organization' })
		}
		if (tabId == 4) {
			router.push({ path: '/about-rules' })
		}
		if (tabId == 5) {
			router.push({ path: '/about-rulesboard' })
		}
	}

	// 게시판 동작 (공지오픈과 동일)
	const searchText = ref('')

	const noticeList = computed(() => {
		return store.state.grid.gridData
	})

	const searchParam = computed(() => {
		return store.state.temp.searchParam 
	})

	const openNoticeJson = computed(() => {
		return Object.assign({}, noticeJson, { boardType: 21 })
	})

	const getGridData = async () => {
		let param = {pageNo : searchParam.value.pageNo, search : searchText.value}
		await store.dispatch('grid/fetchRulesBoard', param)
	}

	const getMessgage = (e) => {
		if(e.origin == process.env.VUE_APP_API_URL) {
			getGridData()
		}
	}

	onMounted(async () => {
		store.commit('temp/clearSearchParam')
		getGridData()
		window.addEventListener('message', getMessgage)
	})

	onUnmounted(() => {
		store.commit('temp/clearSearchParam')
		window.removeEventListener('message', getMessgage)
	})

</script>

<style>

</style>